/**
 * A no-operation function that does nothing.
 * Useful as a default callback or placeholder function.
 */
export function noop() {}
